// extracted by mini-css-extract-plugin
export default {"cajaredes":"RedesSociales_cajaredes__n-bhC","imagen":"RedesSociales_imagen__oVSW4"};